import dayjs from 'dayjs';
import { GridColDef } from '@mui/x-data-grid';
import { Typography } from '@mui/material';

import { removedCellClassName } from '@helpers';
import { TableEnterprise } from '@services';

import { InfoCell } from '@atoms';

export const columns: GridColDef<TableEnterprise>[] = [
  {
    field: 'index',
    headerName: '',
    maxWidth: 60,
    cellClassName: removedCellClassName,
    renderCell: ({ value }) => {
      return <Typography>{value}</Typography>;
    },
    sortable: false,
    filterable: false,
    resizable: false,
  },
  {
    field: 'name',
    headerName: 'Enterprise',
    minWidth: 200,
    flex: 1,
    cellClassName: removedCellClassName,
    renderCell: ({ row: { name, logo } }) => (
      <InfoCell
        name={name}
        avatarUrl={logo ? `${process.env.REACT_APP_CLOUDFRONT_URL}/${logo}` : ''}
      />
    ),
  },
  {
    field: 'fullName',
    headerName: 'Total Number of Staffs',
    minWidth: 150,
    cellClassName: removedCellClassName,
    flex: 1,
    renderCell: () => <></>,
    sortable: false,
  },
  {
    field: 'linkFoundAndDelted',
    headerName: 'Links Found/ Deleted',
    minWidth: 100,
    flex: 1,
    cellClassName: removedCellClassName,
    renderCell: () => <></>,
    sortable: false,
  },
  {
    field: 'createdAt',
    headerName: 'Join Date',
    minWidth: 80,
    flex: 1,
    cellClassName: removedCellClassName,
    renderCell: ({ row: { createdAt } }) => (
      <Typography>{dayjs(createdAt).format('MM.DD.YYYY')}</Typography>
    ),
  },
  {
    field: 'status',
    headerName: 'Monitoring Assets',
    minWidth: 130,
    flex: 1,
    cellClassName: removedCellClassName,
    renderCell: () => <></>,
    sortable: false,
  },
];
